module.exports = __webpack_public_path__ + "static/media/re-chooseQuiz.293b6d1a.svg";